import { Redirect, Route, Switch } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { ColorV2 } from "config/colors";
import { AlertStoreProvider } from "stores/alertStore/alertStore";
import { AuthStoreProvider } from "./stores/authStore/authStore";
import { GlobalStoreProvider } from "./stores/globalStore/globalStore";
import { CompanyApp } from "./web-apps/company/company.app";
import "./services/translation/i18n";
import { EmployeeApp } from "web-apps/employee/employee.app";

const GlobalStyles = createGlobalStyle`
  body {
    background: ${ColorV2.Blue7};
    width: 100%;
    padding: 0 clamp(16px, 1.7vw, 32px);
  }
`;

function App() {
  return (
    <AlertStoreProvider>
      <AuthStoreProvider>
        <GlobalStoreProvider>
          <GlobalStyles />
          <Switch>
            <Route
              exact
              path="/"
              render={() => <Redirect to="company/login" />}
            />
            <Route path="/company">
              <CompanyApp />
            </Route>
            <Route
              exact
              path="/"
              render={() => <Redirect to="employee/login" />}
            />
            <Route path="/employee">
              <EmployeeApp />
            </Route>
          </Switch>
        </GlobalStoreProvider>
      </AuthStoreProvider>
    </AlertStoreProvider>
  );
}

export default App;
